import Home from '@/components/common/Home.vue';

export const affiliateRoutes = {
  path: '/affiliate',
  component: Home,
  name: 'Affiliate',
  redirect: '/affiliate/overall',
  meta: {
    title: 'Affiliate',
  },
  children: [
    {
      path: 'overall',
      component: () => import('@/views/affiliate/AffiliateOverall.vue'),
      meta: {
        title: 'Affiliate Overall',
      },
    },
    {
      path: 'detail',
      meta: {
        title: 'Affiliate Detail',
      },
      component: () => import('@/views/affiliate/AffiliateDetail.vue'),
    },
    {
      path: 'tag',
      component: () => import('@/views/affiliate/Tag.vue'),
      meta: {
        title: 'Affiliate Tag',
      },
    },
    {
      path: 'ddj',
      component: () => import('@/views/affiliate/DDJ.vue'),
      meta: {
        title: 'Affiliate DDJ',
      },
    },
  ],
};
